export const updateCruiseStateroomClassPricing = (cruise, status, sailings) => {
  const newCruiseDetail = cruise;
  sailings?.forEach(sailing => {
    const foundSailingIndex = newCruiseDetail.sailings.findIndex(
      s => s.id === sailing.sailing_id,
    );

    if (foundSailingIndex >= 0) {
      const stateroomClassIndex = newCruiseDetail.sailings[
        foundSailingIndex
      ].stateroomClassPricing.findIndex(
        sc => sc.stateroomClass.id === sailing.cabin_type,
      );

      if (stateroomClassIndex >= 0) {
        if (
          newCruiseDetail.lowestPriceSailing.id === sailing.sailing_id &&
          newCruiseDetail.lowestPriceSailing.lowestStateroomClassPrice
            .stateroomClass.id === sailing.cabin_type
        ) {
          newCruiseDetail.lowestPriceSailing.lowestStateroomClassPrice = {
            ...newCruiseDetail.lowestPriceSailing.lowestStateroomClassPrice,
            uuid: status === 'SELECTED' ? sailing.id : null,
          };
        }
        newCruiseDetail.sailings[foundSailingIndex].stateroomClassPricing[
          stateroomClassIndex
        ] = {
          ...newCruiseDetail.sailings[foundSailingIndex].stateroomClassPricing[
            stateroomClassIndex
          ],
          uuid: status === 'SELECTED' ? sailing.id : null,
        };
      }
    }
  });

  return {
    ...cruise,
    ...(cruise.sailings && {
      sailings: newCruiseDetail.sailings,
    }),
    ...(cruise.lowestPriceSailing && {
      lowestPriceSailing: newCruiseDetail.lowestPriceSailing,
    }),
  };
};
